import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { setButtonState, toggleButtonState } from '../actions/testbutton';
import { callRequestRoll } from '../actions/apiRandomDice';
import { initializeValues, incrementDisplayLayer, decrementDisplayLayer } from '../actions/valueSet';
import valueFixture from '../fixtures/refinedvalues';
import layerArray from '../fixtures/selectionLayers';
import ContinueButton from './continueButton';
import ResetButton from './resetButton';
import OldLayerBlock from './oldLayerBlock';
import SelectionBlock from './selectionBlock';

class ValueGrid extends Component {
  constructor(props) {
    super(props);
    this.props.initializeValueSet();
    this.state = {
      width: 0,
      heigth: 0,
      resizeTimeout: 0,
    };
  }
  componentWillMount() {
    this.updateDimensions();
  }
  componentDidMount() {
    window.addEventListener('resize', this.startBufferedUpdate.bind(this));
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.startBufferedUpdate.bind(this));
  }
  startBufferedUpdate() {
    clearTimeout(this.state.resizeTimeout);
    this.setState({ resizeTimeout: setTimeout(this.updateDimensions.bind(this), 200) });
  }
  updateDimensions() {
    const w = window;
    const d = document;
    const documentElement = d.documentElement;
    const body = d.getElementsByTagName('body')[0];
    const width = w.innerWidth || documentElement.clientWidth || body.clientWidth;
    const height = w.innerHeight || documentElement.clientHeight || body.clientHeight;

    this.setState({ width, height });
  }

  render() {
    return (
      <div>
        {
          this.props.currentDisplayedLayer <= 3 ?
            <h3>{ layerArray[this.props.currentDisplayedLayer].headerText }</h3> : <br />
        }
        {console.log(this.props.currentDisplayedLayer)}
        { layerArray[this.props.currentDisplayedLayer + 1].size === 0 ? '' : <SelectionBlock displayLayer={this.props.currentDisplayedLayer} screenWidth={this.state.width} /> }
        { layerArray[this.props.currentDisplayedLayer + 1].size === 0 ? <OldLayerBlock displayLayer={this.props.currentDisplayedLayer} screenWidth={this.state.width} /> : ''}
        { (this.props.currentDisplayedLayer - 1) >= 0 ? <OldLayerBlock displayLayer={this.props.currentDisplayedLayer - 1} screenWidth={this.state.width} /> : ''}
        { (this.props.currentDisplayedLayer - 2) >= 0 ? <OldLayerBlock displayLayer={this.props.currentDisplayedLayer - 2} screenWidth={this.state.width} /> : ''}
        { (this.props.currentDisplayedLayer - 3) >= 0 ? <OldLayerBlock displayLayer={this.props.currentDisplayedLayer - 3} screenWidth={this.state.width} /> : ''}

        { this.props.currentDisplayedLayer <= 3 ?
          <ContinueButton numToSelect={layerArray[this.props.currentDisplayedLayer + 1].size} funcContinue={this.props.incrementCurrentLayer} isShowBack={this.props.currentDisplayedLayer > 0} funcBack={this.props.decrementCurrentLayer} numSelected={_.reduce(this.props.valuesObject, (accumulator, obj) => accumulator + (obj.layer > this.props.currentDisplayedLayer ? 1 : 0), 0)} />
          :
          <ResetButton funcReset={this.props.resetSelection} funcBack={this.props.decrementCurrentLayer} />

        }
      </div>
    );
  }
}


// This is totally optional, but forces react to check the prop types
// when running in debug
ValueGrid.propTypes = {
  isAwesomeBool: PropTypes.bool.isRequired,
  awesomeOn: PropTypes.func.isRequired,
  awesomeOff: PropTypes.func.isRequired,
  awesomeToggle: PropTypes.func.isRequired,
  getRoll: PropTypes.func.isRequired,
  rollResult: PropTypes.number.isRequired,
  statusText: PropTypes.string.isRequired,
  initializeValueSet: PropTypes.func.isRequired,
  valuesObject: PropTypes.object.isRequired,
  currentDisplayedLayer: PropTypes.number.isRequired,
  incrementCurrentLayer: PropTypes.func.isRequired,
  decrementCurrentLayer: PropTypes.func.isRequired,
  resetSelection: PropTypes.func.isRequired,
};


function mapStateToProps(state, props) {
  return {
    isAwesomeBool: state.testbutton.isOn,
    rollResult: state.apiRandomDice.rollResult,
    statusText: state.apiRandomDice.statusText,
    valuesObject: state.valueSet.values,
    randomIdList: state.valueSet.randomizedIds,
    currentDisplayedLayer: state.valueSet.displayLayer,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    initializeValueSet() {
      dispatch(initializeValues(valueFixture));
    },
    incrementCurrentLayer() {
      dispatch(incrementDisplayLayer());
    },
    decrementCurrentLayer() {
      dispatch(decrementDisplayLayer());
    },
    awesomeOn() {
      dispatch(setButtonState(true));
    },
    awesomeOff() {
      dispatch(setButtonState(false));
    },
    awesomeToggle() {
      dispatch(toggleButtonState());
    },
    getRoll() {
      dispatch(callRequestRoll(2));
    },
    resetSelection() {
      dispatch(initializeValues(valueFixture));
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ValueGrid);



// WEBPACK FOOTER //
// ./src/components/valuegrid.js